import React, { Component } from "react";
import Column from "@amzn/meridian/column";
import Row from "@amzn/meridian/row";
import Button from "@amzn/meridian/button";
import PropTypes from "prop-types";
import { getContainerId } from "../util/ScannerUtils";
import UIUtils from "../util/UIUtils";
import { injectIntl } from "react-intl";

class ScanWithCodeView extends Component {
  keyDown = (e) => {
    if (e.key === "Enter") {
      if (UIUtils.isScanEventAllowed()) {
        if (!this.scanRef.value) {
          this.scanRef.blur();
          return;
        }
        const data = getContainerId(this.scanRef.value);
        this.propagateScan(data);
        this.scanRef.value = "";
      } else {
        this.scanRef.value = "";
      }
    }
  };

  propagateScan = (data) => {
    this.props.onSubmit(data.trim());
  };

  requestFocus = (time) => {
    if (this.props.focusLock) {
      // Set read only true then false to avoid keyboard popping up
      setTimeout(() => {
        if (
          this.scanRef &&
          (document.activeElement !== this.scanRef || this.scanRef.readOnly)
        ) {
          this.scanRef.readOnly = true;
          this.scanRef.focus();
          this.scanRef.readOnly = false;
        }
      }, time);
    }
  };

  componentDidUpdate() {
    this.requestFocus(5);
  }

  componentDidMount() {
    this.requestFocus(20);
    window.addEventListener("visibilitychange", () =>
      this.onVisibilityChange(this),
    );
    window.addEventListener("keydown", this.onWindowKeyDown);
  }

  componentWillUnmount() {
    window.removeEventListener("visibilitychange", this.onVisibilityChange);
    window.removeEventListener("keydown", this.onWindowKeyDown);
  }

  onWindowKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      event.stopPropagation();
    }
  }

  onVisibilityChange(context) {
    if (document.visibilityState === "visible") {
      if (context.scanRef) {
        context.scanRef.readOnly = true;
      }
    }
  }

  onBlur = () => {
    this.requestFocus(20);
  };

  render() {
    const { image, button } = this.props;
    return (
      <Column height="100%" heights="fill">
        <Column alignmentHorizontal="center">
          {image && (
            <Row spacing={"none"} width="70%">
              <img
                src={image}
                alt="no scan"
                height="fit-content"
                id="qr-scan"
                aria-hidden="true"
              />
            </Row>
          )}
          {this.props.onSubmit && (
            <div style={{ zIndex: -1, position: "absolute", opacity: 0 }}>
              <input
                ref={(element) => {
                  this.scanRef = element;
                }}
                autoFocus={true}
                autoComplete={"off"}
                readOnly={"readOnly"}
                type="text"
                onKeyDown={this.keyDown}
                inputMode={"text"}
                onBlur={this.onBlur}
                aria-labelledby="qr-scan"
                aria-label={this.props.ariaLabel}
              />
            </div>
          )}
        </Column>
        {button && (
          <Column width="100%" alignmentVertical="bottom">
            <Button
              onClick={button.onClick}
              size={button.size ? button.size : "large"}
              type={button.type ? button.type : "secondary"}
            >
              {button.title}
            </Button>
          </Column>
        )}
      </Column>
    );
  }
}

ScanWithCodeView.propTypes = {
  image: PropTypes.string,
  button: PropTypes.shape({
    title: PropTypes.string,
    onClick: PropTypes.func,
  }),
  onSubmit: PropTypes.func,
  focusLock: PropTypes.bool,
  ariaLabel: PropTypes.string,
};

export default injectIntl(ScanWithCodeView);



// WEBPACK FOOTER //
// ./src/components/scanBarcode/ScanWithCodeView.js